import script from "./TipTapEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TipTapEditor.vue?vue&type=script&setup=true&lang=js"

import "./TipTapEditor.vue?vue&type=style&index=0&id=58386635&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58386635"]])

export default __exports__